import customArraySort from '@/services/general/customArraySort';

export default function trierFaces(facesATrier) {
  const faces = facesATrier;
  faces.sort(customArraySort(['panCode', 'facCode']));
  return faces;
}



// WEBPACK FOOTER //
// ./src/services/catalogue/trierFaces.js